export const URL_STORAGE = process.env.VUE_APP_STORAGE_URL
export const URL_API = process.env.VUE_APP_BASE_URL